import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

// Which record the current page is about, app-wide, for the assistant: a
// detail page registers it with useCapturePageContext; the drawer reads it
// ("this account" means that record). The note panel that once lived here
// is the drawer now; this is what it left behind.

const CaptureContext = createContext(null);

const NO_CONTEXT = { pageContext: null, setPageContext: () => {} };

export function CaptureProvider({ children }) {
  const [pageContext, setPageContextState] = useState(null);
  const setPageContext = useCallback((ctx) => setPageContextState(ctx), []);
  const value = useMemo(() => ({ pageContext, setPageContext }), [pageContext, setPageContext]);
  return <CaptureContext.Provider value={value}>{children}</CaptureContext.Provider>;
}

export function useCapture() {
  return useContext(CaptureContext) || NO_CONTEXT;
}

/**
 * A detail page says what it is about, for as long as it is on screen:
 *   useCapturePageContext(account ? { account_id: account.id, account_name: account.name } : null)
 * Optional: opportunity_id/opportunity_name, contact_id/contact_name.
 */
export function useCapturePageContext(ctx) {
  const { setPageContext } = useCapture();
  const key = JSON.stringify(ctx || null);
  useEffect(() => {
    setPageContext(key === 'null' ? null : JSON.parse(key));
    return () => setPageContext(null);
  }, [key, setPageContext]);
}
